<template>
  <div class="main">
    <ball :text="'首页'"></ball>
    <div class="nav">
      <!-- <Nav :title="'预约挂号记录'" :fixed="true"></Nav>
      <div class="top"></div> -->
      <div class="nav">
        <van-nav-bar
          title="挂号记录"
          left-arrow
          left-text="返回"
          :fixed="flexfalg"
          @click-left="onClickLeft"
        />
        <div class="top"></div>
      </div>
    </div>
    <div class="cholseDate">
      <div
        class="dateitem"
        :value="begindate"
        @click="showCalendar['begindate'] = true"
      >
        {{ begindate }}
      </div>
      <div class="dateitem_-">~</div>
      <div
        class="dateitem"
        :value="enddate"
        @click="showCalendar['enddate'] = true"
      >
        {{ enddate }}
      </div>
      <van-calendar
        color="#5b8df6"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="showCalendar['begindate']"
        @confirm="(value) => onConfirm(value, 'begindate')"
      />
      <van-calendar
        color="#5b8df6"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="showCalendar['enddate']"
        @confirm="(value) => onConfirm(value, 'enddate')"
      />
    </div>
    <div v-if="showcard">
      
      <div
        class="paycard"
        v-for="(item, index) in cardList"
        :key="index"
        @click="gogaugelist(item.clinicId)"
      >
        <div class="head1">
          <div>预约记录</div>
          <div>{{ item.clientName }}</div>
        </div>
        <div claass="content">
          <div class="Crow">
            <div>发票号:{{ item.invoiceNo }}</div>
            <div class="green" v-if="vtypeflag">
              {{ item.validFlag | Validtext }}
            </div>
          </div>
          <div class="Crow">
            <div>挂号科室名称：{{ item.deptName }}</div>
          </div>
          <div class="Crow">
            <div>预约时间：{{ item.regDate }}</div>
          </div>
          <div class="Crow">
            <div>挂号时间：{{ item.operDate }}</div>
          </div>
          <div class="Crow">
            <div>挂号类型：{{ item.regLevelName }}</div>
          </div>
          <div class="Crow">
            <div>就诊卡号：{{ item.clientId }}</div>
          </div>
          <div class="Crow">
            <div>挂号费</div>
            <div class="red">
              ￥{{ item.regFee ? item.regFee : 0 | FinalPrice }}
            </div>
          </div>
          <div class="Crow">
            <div>就诊状态</div>
            <div>
              {{ item.seeFlag ? "已就诊" : "未就诊" }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="paycard"
        v-for="(item, index) in CompanyList"
        :key="index"
        @click="goqrlist(item.id)"
      >
       <div class="head1">
          <div>单位问卷</div>
          <div>{{ item.clientName }}</div>
        </div>
        <div claass="content">
          <div class="Crow">
            <div>单位名：       {{ item.name }}</div>
          </div>
          <div class="Crow">
            <div>单位地址：      {{ item.address }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showempty" class="empty">
      <van-empty
        image="https://account.kmmds.top/datainfo_pic/error.png"
        description="暂无预约挂号记录"
      />
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import { Dialog, Toast } from "vant";
import ball from "@/components/ball";
import backindex from "@/mixins/backindex";
import setOptions from "@/mixins/setOption";
export default {
  mixins: [backindex, setOptions],
  data() {
    return {
      showCalendar: {
        begindate: false,
        enddate: false,
      },
      isCancel: false,
      show: false,
      begindate: new Date(),
      enddate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2040, 0, 1),
      flexfalg: true,
      vtypeflag: true,
      registerhistoryLIst: [],
      medCardNo: null,
      cardList: [],
      showcard: false,
      showempty: false,
      version: "",
      validtext: "",
      IsRefundfeetodaynow: "",
      CompanyList: [],
    };
  },
  components: {
    Nav,
    ball,
  },
  mounted() {
    // 获取是否取消挂号的配置
    this.getregisterCancel();
    this.getyDay(this.maxDate);
    this.enddate = this.getyDay(this.enddate);
    this.begindate = this.getLmDay(this.begindate);
    if (this.$route.query) {
      this.medCardNo = this.$route.query.clientId;
      // console.log(this.medCardNo)
    }
    if (!this.medCardNo || this.medCardNo == "") {
      // console.log(this.medCardNo);
      this.goconfUser();
      // this.Dialog();
    }
    this.getmedicalcard();
    this.getPayWay();
  },
  // 过滤器
  filters: {
    FinalPrice(regFee) {
      return regFee.toFixed(2);
    },
    Validtext(validFlag) {
      if (validFlag == 1) {
        return "已缴费";
      } else if (validFlag == 0) {
        return "未支付";
      } else if (validFlag == 2) {
        return "订单作废";
      }
    },
  },
  methods: {
    goqrlist(id) {
      this.$router.push({
        path: "/qrgaugelist",
        query: {
          clientId:this.medCardNo,
          surveyId: id,
        },
      });
    },
    async queryallquestionnairesurveyinfo() {
      try {
        this.$showLoad();
        let url = "/gauge/queryallquestionnairesurveyinfo";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.$hideLoad();
            this.CompanyList = data.data.data.data;
            if (this.CompanyList.length == 0) {
              this.showcard = false;
              this.showempty = true;
            } else {
              this.showcard = true;
              this.showempty = false;
            }
          }
        );
      } catch (error) {}
    },
    gogaugelist(item) {
      this.$router.push({
        path: "/gaugelist",
        query: {
          clientId: this.medCardNo,
          clinicId: item,
        },
      });
    },
    async getregisterCancel() {
      try {
        this.$showLoad();
        let url = "/register/isrefundfee";
        let data = {};
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          data,
          (resultData) => {
            this.$hideLoad();
            this.IsRefundfeetodaynow = resultData.data.IsRefundfeetodaynow;
            if (resultData.data.IsRefundfee == "0") {
              this.isCancel = false;
            } else if (resultData.data.IsRefundfee == "1") {
              this.isCancel = true;
            }
          }
        );
      } catch (error) {}
    },
    //获取昨天
    getyDay(date) {
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * 10);
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
    //获取上个月
    getLmDay(date) {
      date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * 30);
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
    //格式化日期
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    //选择日期
    onConfirm(value, type) {
      //  console.log(new Date(value))
      this[type] = this.formatDate(new Date(value));
      this.showCalendar[type] = false;
      this.getmedicalcard();
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    Dialog() {
      // console.log(123)
      this.$dialog
        .confirm({
          message: "请选择就诊人信息",
        })
        .then(() => {
          this.goconfUser();
        })
        .catch(() => {
          // on cancel
          this.$router.push("/index");
        });
    },
    async getmedicalcard() {
      // console.log(this.medCardNo)
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/register/registerRecord";
        let medCardNo = {
          medCardNo: this.medCardNo,
          start_date: this.begindate,
          end_date: this.enddate,
        };
        // console.log(medCardNo);
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          medCardNo,
          (data) => {
            this.$hideLoad();
            this.queryallquestionnairesurveyinfo();
            if (data.data.length != 0) {
              this.cardList = data.data;
              this.cardList.sort(function (a, b) {
                return new Date(b.regDate) - new Date(a.regDate);
              });
              this.showcard = true;
              this.showempty = false;
            } else {
              this.showcard = false;
              this.showempty = true;
            }
          }
        );
      } catch (error) {}
    },
    //go选择用户
    goconfUser() {
      this.$router.push("/patient_card_confUser_C");
    },

    // 退费
    refund(invoiceNo, regdata, thridTradeNo) {
      Dialog.confirm({
        message: "您确定要取消挂号吗？",
      })
        .then(async () => {
          if (this.IsRefundfeetodaynow == 1) {
            //是否今天不能退费的参数
            regdata = regdata.substr(0, 10);
            if (new Date() >= new Date(regdata)) {
              this.$toast.fail("当天不支持线上退费，请到医院收费窗口退费");
              return;
            }
          }
          try {
            this.$showLoad();
            let url = "/register/hisrefundfee";
            let data = {
              invoiceNo: invoiceNo,
              clientId: this.medCardNo,
              version: this.version,
            };
            if (thridTradeNo) {
              data["thridTradeNo"] = thridTradeNo;
            }
            await this.$axios_request.axios_request_body(
              "nodeserver",
              url,
              "POST",
              data,
              (resultData) => {
                this.$hideLoad();

                Toast.fail(resultData.statusText);
                if (resultData.code == -1) {
                  // 弹窗
                  return;
                } else if (resultData.code == 1) {
                  this.getmedicalcard();
                  return;
                }
              }
            );
          } catch (error) {}
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    },
    async getPayWay() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getPayType";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.$hideLoad();
            this.version = data.data.version;
            console.log(this.version);
            let type = data.data.version;
            if (type == "D") {
              this.vtypeflag = false;
            } else {
              this.vtypeflag = true;
            }
            console.log(data);
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.red {
  color: red;
}
.main {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  .top {
    height: 50px;
  }
  .cholseDate {
    widows: 90%;
    display: flex;
    margin: 0px auto;
    margin-top: 10px;
    .dateitem_- {
      margin-left: 20px;
      color: #95a5a6;
    }
    .dateitem {
      margin-left: 20px;
      color: #95a5a6;
      border-bottom: 1px solid #95a5a6;
    }
  }
  .paycard {
    background-color: #fafafa;
    padding: 5px;
    width: 93%;
    display: flex;
    flex-direction: column;
    // border: 1px solid #5b8df6;
    border-radius: 8px;
    margin: 0px auto;
    margin-top: 8px;
    margin-bottom: 8px;
    // box-shadow: 0 8px 12px #6666;
    box-shadow: 0 1px 3px #5b8df6;
  }
  .head1 {
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 10px;
    color: #5b8df6;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dashed #5b8df6;
    font-size: 16px;
    line-height: 30px;
  }
  .content {
    width: 90%;

    display: flex;
    flex-direction: column;
    border: 1px solid #95a5a6;
    border-radius: 15px;
    margin: 5px auto;
  }
  .Crow {
    color: #747d8c;
    margin-left: 20px;
    margin-right: 20px;
    line-height: 30px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .gold {
      color: #e74c3c;
    }
    .green {
      color: #2ed573;
    }
  }
  .line {
    border-bottom: 1px solid #95a5a6;
  }
}
// 退费
// .refund_btn {
//   background-color: #5b8df6;
//   width: 70px;
//   margin-right: -5px;
//   height: 30px;
//   line-height: 30px;
//   border-radius: 5px;
//   color: #ffffff;
//   letter-spacing: 3px;
//   border: 0px;
// }
</style>